export default __webpack_public_path__ + "assets/31e6719c4973e644ed20d0db61582e56.jpg";